import { forwardRef } from "react"
import styles from "./styles.module.scss"
import { Skeleton } from "antd"

export const NotificationSkeleton = forwardRef<any, any>((props, ref) => {
  return (
    <div ref={ref} className={styles.notificationSkeleton} {...props}>
      <Skeleton.Avatar active size={"small"} shape={"circle"} />
      <div>
        <Skeleton.Input active size={"small"} block />
        <Skeleton.Input active size={"small"} block />
      </div>
    </div>
  )
})
